"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VerifiedIcon = void 0;

var _react = _interopRequireDefault(require("react"));

var _helpers = require("../helpers");

var _Icon = require("./Icon");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

/** VerifiedIcon */
var VerifiedIcon = function VerifiedIcon(props) {
  return _react.default.createElement(_Icon.Icon, _extends({}, props, {
    viewBox: "0 0 18 18"
  }), _react.default.createElement("title", null, "Verified"), _react.default.createElement("defs", null, _react.default.createElement("path", {
    d: "M5.2 3.085l-.497 1.172a.85.85 0 01-.446.446L3.085 5.2a1.779 1.779 0 00-.955 2.304l.477 1.18a.837.837 0 010 .63l-.477 1.182c-.363.9.061 1.925.955 2.304l1.172.497c.2.086.36.246.446.446l.497 1.172a1.78 1.78 0 002.304.955l1.181-.477a.837.837 0 01.631 0l1.18.477a1.78 1.78 0 002.304-.955l.497-1.172a.85.85 0 01.447-.446l1.171-.497a1.778 1.778 0 00.955-2.304l-.477-1.181a.846.846 0 010-.63l.477-1.181c.364-.9-.06-1.925-.955-2.304l-1.171-.497a.85.85 0 01-.447-.446L12.8 3.085A1.778 1.778 0 0011.162 2c-.222 0-.448.042-.666.13l-1.18.477a.846.846 0 01-.63 0L7.503 2.13a1.779 1.779 0 00-2.304.955zm4.467.39l1.18-.477a.84.84 0 011.09.452l.498 1.171c.18.426.518.763.944.944l1.171.498a.84.84 0 01.452 1.09l-.476 1.18a1.776 1.776 0 000 1.334l.476 1.18a.84.84 0 01-.452 1.091l-1.171.497c-.426.18-.763.518-.944.942l-.497 1.173a.841.841 0 01-1.09.451l-1.181-.476a1.776 1.776 0 00-1.334 0l-1.18.476a.842.842 0 01-1.091-.451l-.497-1.173a1.78 1.78 0 00-.942-.942l-1.173-.497A.842.842 0 013 10.847l.476-1.18a1.776 1.776 0 000-1.334l-.476-1.18a.84.84 0 01.451-1.09l1.173-.498c.424-.18.762-.518.942-.944l.497-1.171a.84.84 0 011.091-.452l1.18.476a1.777 1.777 0 001.333 0zM11.41 6.86l-3.31 3.31-1.323-1.324a.561.561 0 10-.794.794l1.72 1.72c.22.221.574.221.794 0l3.707-3.706a.562.562 0 000-.794.56.56 0 00-.794 0z",
    id: "prefix__a"
  })), _react.default.createElement("use", {
    fill: (0, _helpers.color)(props.fill) || (0, _helpers.color)("black100"),
    xlinkHref: "#prefix__a",
    fillRule: "evenodd"
  }));
};

exports.VerifiedIcon = VerifiedIcon;
VerifiedIcon.displayName = "VerifiedIcon";
//# sourceMappingURL=VerifiedIcon.js.map